/**
 * Helpers to get the "current" lastScore for plan generation etc.
 * Prefers the in-memory window.lastScore (from active calculate in this session).
 * Falls back to the most recent entry in af_pt_history (for "existing saved score on dashboard"
 * after reload / cache clear / plan clear).
 *
 * This allows generating plans from a previously saved score without forcing a re-record
 * of the full test details every time.
 */

export function getLatestScoreFromHistory(): any | null {
  try {
    const histRaw = localStorage.getItem('af_pt_history');
    if (!histRaw) return null;
    const hist = JSON.parse(histRaw);
    if (!Array.isArray(hist) || hist.length === 0) return null;

    const entry = hist[0];
    // Strip the extra metadata we add in saveScore (id, recordedDate, ufpm*, _synced, etc.)
    // Keep the core shape that buildAIPrompt / lastScore expects (composite, puScore, etc.)
    const {
      id,
      recordedDate,
      officialTestDate,
      testDate,
      ufpmMemberId,
      ufpmMemberName,
      _synced,
      ...coreScore
    } = entry;

    // Basic sanity: needs a composite at least
    if (coreScore && (coreScore.composite != null || coreScore.puScore != null)) {
      return coreScore;
    }
  } catch {
    // bad json or storage
  }
  return null;
}

export function ensureLastScoreHydrated(): any | null {
  if (window.lastScore) {
    return window.lastScore;
  }

  const fromHist = getLatestScoreFromHistory();
  if (fromHist) {
    window.lastScore = fromHist;
    // Notify listeners (useAIPlan, dashboard, legacy updateAISummary etc.)
    try {
      window.dispatchEvent(new CustomEvent('ptr:score-ready'));
    } catch {}
    return fromHist;
  }

  return null;
}
